import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Check } from 'lucide-react';
import '../styles/about.css';

const About = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  const features = [
    'Presupuesto gratuito',
    'Equipo propio cualificado',
    'Atención en español e inglés',
    'Sin sorpresas en el precio',
    'Garantía en todos los trabajos',
    'Servicio post-obra incluido',
  ];

  return (
    <section id="nosotros" className="about" ref={sectionRef}>
      <div className="about-container">
        <motion.div
          className="about-image-wrapper"
          initial={{ opacity: 0, x: -50 }}
          animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
          transition={{ duration: 0.8 }}
        >
          <img
            src="https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=800&q=80"
            alt="Reforma integral de vivienda"
            className="about-image"
            loading="lazy"
          />
          <div className="about-badge">
            <div className="badge-number">+20</div>
            <div className="badge-text">Años en la<br />Costa Blanca</div>
          </div>
        </motion.div>

        <motion.div
          className="about-content"
          initial={{ opacity: 0, x: 50 }}
          animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <span className="section-label">QUIÉNES SOMOS</span>
          <h2 className="section-title">Más de 20 Años Construyendo Confianza</h2>
          <p className="about-description">
            Ideas Costa Blanca es una empresa integral especializada en construcción, reformas y mantenimiento
            en toda la provincia de Alicante. Con más de 500 proyectos completados, nos hemos convertido en
            la referencia de confianza para particulares, comunidades de vecinos y empresas.
          </p>
          <p className="about-description">
            Nuestro compromiso es ofrecer un servicio completo con un solo punto de contacto. Desde pequeñas
            reparaciones hasta proyectos de grandes dimensiones, gestionamos cada detalle con profesionalidad y
            transparencia absoluta.
          </p>

          <div className="about-features">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                className="about-feature"
                initial={{ opacity: 0, x: 20 }}
                animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 20 }}
                transition={{ duration: 0.5, delay: 0.4 + index * 0.1 }}
              >
                <div className="feature-check">
                  <Check size={16} strokeWidth={3} />
                </div>
                <span className="feature-text">{feature}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;